import settings from "@/core/settings"

export default async function currencyFormats() {
  // this is exposed via an async wrapper to allow for lazy loading
  return settings.currencySettings ?? {}
}
